import { newSpecPage } from '@stencil/core/testing'
import { CobaltTextarea } from '../cobalt-textarea'

describe('cobalt-textarea', () => {
  it('Should render Textarea element', async () => {
    const page = await newSpecPage({
      components: [CobaltTextarea],
      html: '<cobalt-textarea label="Label" placeholder="placeholder"></cobalt-textarea>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-textarea label="Label" placeholder="placeholder">
        <core-textarea label="Label" placeholder="placeholder" format="outside" label="Label" requirement="mandatory"></core-textarea>
      </cobalt-textarea>
    `)
  })
  it('Should change format to aside', async () => {
    const page = await newSpecPage({
      components: [CobaltTextarea],
      html: '<cobalt-textarea label="Label" placeholder="placeholder" format="aside"></cobalt-textarea>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-textarea label="Label" placeholder="placeholder" format="aside">
        <core-textarea format="aside" label="Label" placeholder="placeholder" label="Label" requirement="mandatory"></core-textarea>
      </cobalt-textarea>
    `)
  })
  it('Should change format to hidden', async () => {
    const page = await newSpecPage({
      components: [CobaltTextarea],
      html: '<cobalt-textarea label="Label" placeholder="placeholder" format="hidden"></cobalt-textarea>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-textarea label="Label" placeholder="placeholder" format="hidden">
        <core-textarea format="hidden" label="Label" placeholder="placeholder" format="outside" label="Label" requirement="mandatory"></core-textarea>
      </cobalt-textarea>
    `)
  })
  it('should render Textarea in error state', async () => {
    const page = await newSpecPage({
      components: [CobaltTextarea],
      html: '<cobalt-textarea label="Label" error-message="This field is required"></cobalt-textarea>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-textarea error-message="This field is required" label="Label">
        <core-textarea errormessage="This field is required" format="outside" label="Label" requirement="mandatory"></core-textarea>
      </cobalt-textarea>
    `)
  })
})
